import React from 'react';
import clsx from 'clsx';
import CardTitle from './CardTitle';
import ActionBar from '../ActionBar';

type InitialValues = {
  modelType: string;
  modelsToAssign: string[];
  slideShowSelect: string;
};

interface FullWidthCardProps {
  borderLeft?: boolean;
  Icon?: any;
  iconSrc?: string;
  initialValues?: InitialValues;
  isAssigned?: boolean;
  isStaffer?: boolean;
  pacing?: string;
  page?: number;
  presentPath: string;
  title: string;
  unitColor?: string;
}

const FullWidthCard = ({
  borderLeft = false, Icon, iconSrc, initialValues, isAssigned, isStaffer, pacing, page, presentPath, title, unitColor,
}: FullWidthCardProps) => (
  <section
    aria-label={title}
    className={clsx(
      'card tw-relative tw-w-full tw-h-24 tw-m-2 tw-rounded-md tw-mr-16', {
        'tw-border-l-[0.25rem] tw-border-l-solid': borderLeft,
      },
    )}
    style={{ borderLeftColor: borderLeft && `#${unitColor}` }}
  >
    <div className="tw-flex tw-h-full">
      <div className="tw-flex tw-items-center tw-w-24">
        <div
          className={clsx(
            'tw-flex tw-w-full tw-py-2 tw-justify-center',
            'tw-border-r tw-border-solid tw-border-r-med-grey',
          )}
        >
          {Icon ?? (
            <img
              aria-hidden
              alt=""
              src={iconSrc}
            />
          )}
        </div>
      </div>
      <div
        className={clsx('tw-grow tw-ml-5 tw-my-4', {
          '!tw-my-auto': !page && !pacing,
        })}
      >
        <CardTitle
          fullWidth
          halfCard
          linkHref={presentPath}
          linkLabel={title}
          page={page}
          target=""
          time={pacing}
          unitColor={unitColor}
        />
      </div>
      <div className="tw-ml-auto tw-my-auto">
        <ActionBar
          border={false}
          href={presentPath}
          iconType="play"
          initialValues={initialValues}
          isAssigned={isAssigned}
          isStaffer={isStaffer}
        />
      </div>
    </div>
  </section>
);

export default FullWidthCard;
